class JsonError extends Error {
    constructor(message) {
        super(message);
        this.name = "JsonError";
    }
}

export default JsonError;